import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchMemberTypes } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

const MEMBER_CLASS_LABELS = {
  Collaborator: "memberType.class.Collaborator",
  CompanyMember: "memberType.class.CompanyMember",
  Specialist: "memberType.class.Specialist",
  Investor: "memberType.class.Investor",
  ProductUser: "memberType.class.ProductUser",
};

export default function MemberTypeListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    try { setRows(await fetchMemberTypes(businessDomainId)); }
    catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadData(); }, [businessDomainId]);

  const columns = [
    { field: "memberTypeName", headerName: t("memberType.name"), flex: 1, minWidth: 200 },
    {
      field: "memberClass",
      headerName: t("memberType.memberClass"),
      width: 160,
      valueFormatter: (value) => {
        const key = MEMBER_CLASS_LABELS[value];
        return key ? t(key) : value || "";
      },
    },
  ];

  const handleRowClick = (params) => {
    navigate(`/design/${businessDomainId}/member-types/${params.row.memberTypeId}`);
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("memberType.list.title")}</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate(`/design/${businessDomainId}/member-types/create`)}>{t("common.add")}</Button>
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(r) => r.memberTypeId}
        loading={loading}
        autoHeight
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        disableRowSelectionOnClick
        onRowClick={handleRowClick}
        sx={{
          "& .MuiDataGrid-row": { cursor: "pointer" },
          "& .MuiDataGrid-row:hover": { backgroundColor: "action.hover" },
        }}
      />
    </Box>
  );
}
